/**
 * Trace GraphQL Mutations (2 total)
 *
 * Complete mutation coverage for Trace primitive:
 * 1. createTrace - Create new trace span
 * 2. updateTrace - Update existing trace (e.g., end span)
 */

import { gql } from '@apollo/client';
import { TRACE_FIELDS } from './fragments';

/**
 * Create new trace span
 */
export const CREATE_TRACE = gql`
  ${TRACE_FIELDS}
  mutation CreateTrace($input: CreateTraceInput!) {
    createTrace(input: $input) {
      ...TraceFields
    }
  }
`;

/**
 * Update existing trace (e.g., end span, add metrics)
 */
export const UPDATE_TRACE = gql`
  ${TRACE_FIELDS}
  mutation UpdateTrace($tenantId: String!, $traceId: String!, $input: UpdateTraceInput!) {
    updateTrace(tenantId: $tenantId, traceId: $traceId, input: $input) {
      ...TraceFields
    }
  }
`;
